import {Component, Output, EventEmitter} from '@angular/core';
import {Router} from "@angular/router";
import {
  TokenCancelAuthorizationService
} from "../../lib/services/token-cancel-authorization/token-cancel-authorization.service";
import {ToastService} from "../../lib/services/toast/toast.service";
import {AuthenticationService} from "../../lib/services/autenticacion/authentication.service";
import {TokenCancelService} from "../../lib/services/token-cancel/token-cancel.service";

@Component({
  selector: 'lib-token-cancel-authorization',
  templateUrl: './token-cancel-authorization.component.html',
  styleUrls: ['./token-cancel-authorization.component.scss']
})
export class TokenCancelAuthorizationComponent  {

  modalMessage = ''
  codeSent = true;
  validCode = false;
  codeIntroduced: string = "";
  errorCodeIntroduced: boolean = false;
  validating: boolean = false;
  resending: boolean = false
  // @Output() tokenBlockedError: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private tokenCancelAuthorizationService: TokenCancelAuthorizationService,
    private toastService: ToastService,
    private router: Router,
    private authenticationService: AuthenticationService,
    private tokenCancelService: TokenCancelService
    ) {
  }

  closeModal() {
    this.tokenCancelAuthorizationService.close()
  }

  showModalForCode() {
    this.closeModal()
    this.tokenCancelService.open()
  }

}
